const bits = "bits";

export function getBits() {
  return localStorage.getItem(bits);
}

export function setBits(data) {
  return localStorage.setItem(bits, data);
}

export function removeBits() {
  return localStorage.removeItem(bits);
}
